<template>
    <div>
        <div :class="{ 'c-content__expandable-min' : isMin, 'c-content__expandable' : !isMin, 'c-content__expanded': isExpanded || !isCollapsed}">
            <slot>
                <!---->
            </slot>
            <div class="c-content__shading" v-show="isCollapsed && !isExpanded" :style="{'background': `linear-gradient(to top, ${color}, rgba(255, 255, 255, 0))`}"></div>
        </div>
        <div class="u-text-center" v-show="isCollapsed && !isExpanded">
            <div class="c-content__more-block" @click="expand" v-text="t('Read more')"></div>
<!--            <button type="button" class="c-content__more-button c-button c-button&#45;&#45;inline c-button&#45;&#45;uppercase c-button&#45;&#45;primary" @click="expand" v-text="t('Read more')"></button>-->
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import IsMobile from '../helpers/isMobile';
import BaseComponent from './Base';

@Component
    export default class ExpandableContent extends BaseComponent {
        @Prop({ type: String, default: '#fff' }) protected readonly color: string;
        @Prop({ type: Boolean, default: false }) protected readonly isMin: boolean;
        @Prop({ type: Boolean, default: false }) protected readonly alwaysOpenOnDesktop: boolean;

        protected isCollapsed: boolean = false;
        protected isExpanded: boolean = false;
        protected resizeObserver: any = null;

        public expand(): void {
            this.isExpanded = true;
        }

      /**
       * TODO: maybe need optimization
       * @protected
       */
        protected observeHeight(): void {
            if ('ResizeObserver' in window && this.$el) {
                this.resizeObserver = new window.ResizeObserver(() => {
                    this.onWindowResize();
                });

                this.resizeObserver.observe(this.$el);
            }
        }

        protected onWindowResize(): void {
            // if (this.$el.offsetHeight > ( window.innerHeight / 2)) {
            if (this.$el.offsetHeight > (2 * window.innerHeight / 6)) {
                this.isCollapsed = true;
            }
            if (this.alwaysOpenOnDesktop && !IsMobile.detectMobile()) {
                this.isCollapsed = false;
            }
        }

        protected mounted(): void {
            this.$nextTick(() => {
                this.onWindowResize();
                this.observeHeight();
            });

            EventBus.$on('windowResize', this.onWindowResize);
        }

        protected beforeDestroy(): void {
            if (this.resizeObserver && this.$el) {
                this.resizeObserver.unobserve(this.$el);
            }
        }
    }
</script>
